import {createSelector} from "reselect";
import {
    selectCalendarState
} from "./calendarSelector";
import {selectArtistMap} from "../common/commonSelector";
import {MULTIPLE_ARTIST_VIEW} from "./CalendarReducer";
import {createFieldSelector} from "../utils/selectors";
import {selectLoggedInArtist} from "../auth/authSelector";

const EMPTY_ARTIST_ID_LIST = [];

export const selectResourceFilter = createSelector(
    [selectCalendarState
    , selectLoggedInArtist]
    , (state, loggedInArtist) => state.resourceFilter || {tatortId: loggedInArtist?.StdOrtID || -1}
)

export const selectSelectedTatorIdOfResourceFilter = createFieldSelector(selectResourceFilter, 'tatortId')

/**
 * Selects relevant artist IDs for timeslot search based on view type and selected artist.
 * 
 * Uses input-props pattern: receives viewType and artistId from URL-SSOT (via useEffectiveCalendarSettings).
 * No longer depends on deprecated Redux settings selectors.
 * 
 * @param {Object} state - Redux state
 * @param {Object} input - Settings input object with viewType and artistId
 * @returns {Array<number>|undefined} Array of artist IDs or undefined
 */
export const selectRelevantArtistsForTerminslotSearch = createSelector(
    [selectArtistMap
    , (state, input) => input?.viewType
    , (state, input) => input?.artistId
    , (state, input) => input?.viewableArtistIdList || EMPTY_ARTIST_ID_LIST]
    , (artistMap, viewType, artistId, viewableArtistIdList) =>  artistMap
        && ( viewType === MULTIPLE_ARTIST_VIEW ? Object.values(artistMap)
        .filter(a => !a.Ausgeschieden && viewableArtistIdList.includes(a.ArtistID))
                .map(a => a.ArtistID)
                : viewableArtistIdList.includes(artistId) ? [artistId] : EMPTY_ARTIST_ID_LIST)
)
